import {TweenMax} from 'TweenMax';
// import select from '../filter/filter';
// import qs from '../../scripts/util/DOM/qs';

// import qsa from '../../scripts/util/DOM/qsa';
//  import {build, compile} from '../../scripts/renderTemplate';
// import {forEach} from 'ramda';
import isElement from '../../scripts/util/isElement';
// import ScrollMagic from 'ScrollMagic';
import TimelineMax from 'TimelineMax';
import $ from 'jquery';

const selectors = {
	page: '.js-catalog-design',
	pageCompetition: '.catalog-design--competition',
	mainCatalog: '.main-catalog-design',
	catalogMenu: '.js-menu-catalog-top',
	catalog: {
		trigger: '.js-catalog-trigger'
	},
	content: '.designs__wrap',
	preview: '.designs__item--box',
	previewTmp: '#preview-tmp',
	likeButton: '.designs__link_competition',
	like: {
		wrap: '.link_style_competition'
	}
};

const designCatalogAnim = () => {
	const page = document.querySelector(selectors.page);
	const trigger = page.querySelectorAll(selectors.catalog.trigger);
	for (let i = 0; i < trigger.length; i++) {
		const tween = new TimelineMax();
		tween.add([
			TweenMax.fromTo(trigger[i], 1, {alpha: 0}, {alpha: 1, ease: 'Sine'})
		]);

		// new ScrollMagic.Scene({
		// 	triggerHook: 1,
		// 	triggerElement: trigger[i],
		// 	offset: -50
		// })
		// .setTween(tween)
		// .addTo(controller);
	}
};

// const classes = {
// 	fade: 'designs__preview_fade',
// 	hide: 'hide',
// 	activeFilter: 'filter__item_active',
// 	firstLoadItemClass: 'designs__wrap--first-load',
// 	like: {
// 		checked: 'designs__link_competition_checked',
// 		wrapHide: 'link_style_competition--hide'
// 	}
// };

// const fade = elem => elem.classList.remove(classes.fade);

// const fadeAll = forEach(fade);

// const animate = () => {
// 	const previews = qsa(selectors.preview);
//
// 	setTimeout(() => {
// 		fadeAll(previews);
// 	}, 300);
// };

// const element = qs(selectors.previewTmp);

// const insert = (block, output) => {
// 	block.innerHTML = output.join(' ');
// 	animate();
// 	// refreshFilterPosition();
// };

// const append = (block, output) => {
// 	output.map(item => {
// 		const div = document.createElement('span');
// 		div.innerHTML = item;
// 		block.appendChild(div.firstElementChild);
// 	});
//
// 	animate();
// 	// refreshFilterPosition();
// };

/*
const isAllowLike = name => {
	const value = localStorage.getItem(name);
	let result = false;

	if (!value) {
		result = true;
	}

	return result;
}; */

const showPopUp = () => {
	$('.competition__question-popup').addClass('competition__question-popup_open');
	$('body').addClass('body_hidden');
	$('.page').addClass('noscroll');
};

const hidePopUp = () => {
	$('.competition__question-popup').removeClass('competition__question-popup_open');
	$('body').removeClass('body_hidden');
	$('.page').removeClass('noscroll');
};

const clearPreviousData = () => {
	// $('#like').val('');
	localStorage.removeItem('like');
	$('#social-data').html('');
};

/* const sendLike = (id, social) => {
	$.ajax({
		url: '/send-like',
		type: 'POST',
		dataType: 'json',
		data: {id, social, _csrf: $('meta[name="csrf-token"]').prop('content')},
		success: response => {
			if (response.data.success === true) {
				const link = $('.designs__link_competition[data-id=' + id + ']');
				const countBlock = link.find(selectors.like.wrap);
				const count = parseInt(countBlock.text(), 10) + 1;
				countBlock.text(count);
				countBlock.removeClass(classes.like.wrapHide);
				link.data('state', 'checked');
				link.addClass(classes.like.checked);
				localStorage.setItem('blog-' + id, new Date());
			}
			clearPreviousData();
			hidePopUp();
		}
	});
}; */

const initPopUpEvents = () => {
	$('.competition__question-popup-close-icon').on('click', function (e) {
		e.preventDefault();
		hidePopUp();
	});
/*	$('.competition__question-popup-social-icon').on('click', function (e) {
		e.preventDefault();
		console.log('click');
		const network = $(this).data('network');
		$('.ulogin-button-' + network).click();
	});*/
};


const initLikesEvents = () => {
	$(selectors.likeButton).on('click', function (e) {
		e.preventDefault();
		clearPreviousData();
/*		if (!$(this).hasClass('designs__link_competition_checked')) {
			const id = $(this).data('id');
			const storageName = 'blog-' + id;
			if (isAllowLike(storageName)) {
				// $('#like').val(id);
				localStorage.setItem('like', id);
				showPopUp();
			}
		} */
		showPopUp();
	});

/*	$('#like').on('click', function (e) {
		e.preventDefault();
		const data = $('#social-data').html();
		const socialData = JSON.parse(data);
		// const likeId = $(this).val(); // заменить
		const likeId = localStorage.getItem('like');
		console.log('like');
		sendLike(likeId, socialData);
	}); */

	/* $(selectors.likeButton).each(function (index, elem) {
		const id = $(elem).data('id');
		const storageName = 'blog-' + id;
		if (!isAllowLike(storageName)) {
			$(elem).addClass(classes.like.checked);
		}
	}); */
};

const initCompetitionMenuEvents = () => {

	$('.js-catalog-design .js-menu-catalog-top .js-select-native').change(function () {
		if (!$(this).find('option:selected').hasClass('default')) {
			const key = $(this).find('option:selected').val();
			// const scroll = new ScrollMagic.Controller();
			designCatalogAnim();
			$('.designs__wrap > div').hide();
			$('.cat_' + key).show();
			if (key === 'all') {
				history.pushState({templates: key}, 'Title', '/templates');
			} else {
				history.pushState({templates: key}, 'Title', '/templates/' + key);
			}
		}
	});

	$('.js--filter__item').on('click', function (e) {
		e.preventDefault();
		if (!$(this).hasClass('filter__item_active')) {
			const key = $(this).data('filter');
			// const scroll = new ScrollMagic.Controller();
			if ($(window).width() > 767) {
				designCatalogAnim();
			}

			if ($('.main-catalog-design').length) {
				$('.designs__wrap > div').hide();
				$('.cat_' + key).show();

				// setTimeout(function () {
				// 	TweenMax.to($('html body'), 1, {
				// 		scrollTo: {y: $('.filter__list').offset().top, autoKill: true},
				// 		// ease: Power1.easeOut,
				// 		overwrite: 5
				// 	});
				// }, 300);

				/* eslint-disable */
				if (key === 'all') {
					history.pushState({templates: key}, 'Title', '/templates');
					ga('set', 'page', '/templates');
				} else {
					history.pushState({templates: key}, 'Title', '/templates/' + key);
					ga('set', 'page', '/templates' + key);
				}
				/* eslint-enable */
			}
			// } else {
			// 	if (key === 'prize') {
			// 		$('.js-competition-prize').removeClass('competition__wrap--hide');
			// 		$('.js-competition-designs').addClass('competition__designs--hide');
			// 	} else {
			// 		$('.js-competition-designs').find('.designs').addClass('competition__designs--hide');
			// 		$('#' + key).removeClass('competition__designs--hide');
			// 		$('.js-competition-prize').addClass('competition__wrap--hide');
			// 		$('.js-competition-designs').removeClass('competition__designs--hide');
			// 	}
			// }



			$('.js-menu-catalog-top').find('.filter__item').removeClass('filter__item_active');
			$(this).addClass('filter__item_active');
		}
	});
};

const render = () => {

	if (isElement(selectors.page)) {
		const categories = ['/templates/all', '/templates/portfolio', '/templates/ecommerce', '/templates/services'];
		if ($.inArray(window.location.pathname, categories) > -1) {
			window.location.replace(window.location.origin + '/templates');
		}
	}

	if (isElement(selectors.pageCompetition)) {
		initPopUpEvents();
		initLikesEvents();

	}
	initCompetitionMenuEvents();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/catalog-design/catalog-design.js